
import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class ActivityType extends Mappeable {

    idActivityTypePk: number;
    txtDsp: string;
    mrkActive: boolean;
    txtNam: string;
    typeActivityFather: any;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
        //this.typeActivityFather = this.typeActivityFather ??  null 
    }

    public mapToBack() {
        return {
            txtDsp: this.txtNam,
            txtNam: this.txtNam,
            mrkActive: this.mrkActive,
            typeActivityFather: this.typeActivityFather
        }
    }

}
